import { SortOrder } from "../Table/Table";

export default function SortIcon({ order }: { order: SortOrder | undefined }) {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 -3 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.6079 4.57036L4.87623 0.0960542C4.76942 -0.0320181 4.56375 -0.0320181 4.4558 0.0960542L0.724131 4.57036C0.5855 4.7372 0.710495 4.9816 0.934349 4.9816H8.39768C8.62154 4.9816 8.74653 4.7372 8.6079 4.57036Z"
        fill="white"
        opacity={order === "ascend" ? 0.5 : 1}
      />
      <path
        d="M8.39768 7.0184H0.934349C0.710495 7.0184 0.5855 7.2628 0.724131 7.42964L4.4558 11.9039C4.56261 12.032 4.76828 12.032 4.87623 11.9039L8.6079 7.42964C8.74653 7.2628 8.62154 7.0184 8.39768 7.0184Z"
        fill="white"
        opacity={order === "descend" ? 0.5 : 1}
      />
    </svg>
  );
}
